import Image from '@/components/Image/RemoteImage';
import Container from '@/components/Container';

function BookCoverImage({ coverUrl, coverAltText }) {
  return (
    <div className="relative flex rounded-md shadow-2xl">
      <div className="relative z-10 flex origin-center transform cursor-pointer rounded-md transition duration-300 ease-in-out hover:-rotate-3 hover:shadow-2xl">
        <Image
          src={coverUrl}
          alt={coverAltText}
          className="block h-auto max-w-full rounded-md"
          width={960}
          height={1390}
        />
      </div>
      <div className="absolute inset-0 z-0 rounded-md bg-white shadow" />
    </div>
  );
}

function BookTitle({ title }) {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold leading-tight tracking-tight lg:text-5xl lg:font-extrabold">
        {title}
      </h2>
    </div>
  );
}

function BookExcerptContent({ children }) {
  return (
    <div className="space-y-2 text-base font-medium leading-normal tracking-tight text-gray-500 lg:leading-relaxed">
      <p>{children}</p>
    </div>
  );
}

function BookActions({ url }) {
  return (
    <div className="flex items-center pt-2">
      <a
        className="inline-flex rounded-full bg-gray-900 px-5 py-3 font-semibold leading-none text-white shadow hover:bg-gray-800 hover:shadow-lg focus:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-800 focus:ring-opacity-20"
        href={url}
      >
        Obtener el libro
      </a>
    </div>
  );
}

export default function Books() {
  return (
    <div className="bg-white">
      <div className="relative overflow-hidden bg-white bg-gradient-to-tr from-green-100 to-white py-10 lg:py-20">
        <Container className="relative z-10">
          <div className="mx-auto max-w-screen-lg">
            <div className="grid grid-cols-1 lg:grid-cols-6 lg:gap-10 xl:gap-16">
              <div className="md:col-span-2">
                <BookCoverImage
                  coverUrl="v1610716279/libros/agilidad-scrum-mas-y-mejores-resultados_idbrrq.jpg"
                  coverAltText="Agilidad y Scrum: Más y Mejores Resultados"
                />
              </div>
              <div className="space-y-6 md:col-span-4 md:flex md:flex-col md:justify-center">
                <BookTitle title="Agilidad y Scrum: más y mejores resultados" />
                <BookExcerptContent>
                  En este libro hacemos recopilación de la información más
                  relevante acerca de Agilidad y Scrum basados en nuestra
                  experiencia, de más de 12 años trabajando en proyectos de
                  desarrollo de productos, sobre todo en la industria del
                  software.
                </BookExcerptContent>
                <BookActions url="https://www.amazon.com/-/es/Adonis-Ricardo-Rosales-Garc%C3%ADa-M-Sc/dp/B084DP1NRJ/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1608170626&sr=8-1" />
              </div>
            </div>
          </div>
        </Container>
        <div className="absolute inset-0 z-0">
          <div className="absolute left-0 z-0 -ml-32 -mt-20 h-80 w-2/6 -skew-y-6 transform bg-gradient-to-l from-transparent to-green-400" />
          <div className="absolute left-0 z-0 -ml-32 h-40 w-2/4 -skew-y-6 transform bg-gradient-to-l from-transparent to-green-200" />
          <div className="absolute right-0 bottom-0 z-0 -mr-32 h-40 w-2/6 -skew-y-6 transform bg-gradient-to-r from-transparent to-green-200" />
          <div className="absolute right-0 bottom-0 z-0 -mr-32 -mb-20 h-24 w-2/3 -skew-y-6 transform bg-gradient-to-r from-transparent to-green-400" />
        </div>
      </div>
      <div className="relative overflow-hidden bg-white bg-gradient-to-tr from-orange-100 to-white py-10 lg:py-20">
        <Container className="relative z-10">
          <div className="mx-auto max-w-screen-lg">
            <div className="grid grid-cols-1 lg:grid-cols-6 lg:gap-10 xl:gap-16">
              <div className="md:col-span-2">
                <BookCoverImage
                  coverUrl="v1611712507/libros/historias-de-usuario-una-vision-pragmatica_riwpi8.jpg"
                  coverAltText="Historias de usuario: Una visión pragmática"
                />
              </div>
              <div className="space-y-6 md:col-span-4 md:flex md:flex-col md:justify-center">
                <BookTitle title="Historias de usuario: Una visión pragmática" />
                <BookExcerptContent>
                  Este libro es una recopilación de muchos artículos previos de
                  los autores publicados en sus blogs y en otros sitios
                  especializados, sumado a material totalmente nuevo y a
                  numerosos ejemplos prácticos que enriquecen y extienden el
                  trabajo original.
                </BookExcerptContent>
                <BookActions url="https://www.amazon.com/-/es/Lucho-Salazar-ebook/dp/B07HLYX68Z" />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
